import React, { Component, Fragment } from "react";
import { Modal, Button } from "src/components/shared";
import { string, func, bool, object, oneOfType } from "prop-types";

export default class DialogModalWindow extends Component {
  render() {
    const {
      title,
      isOpen,
      children,
      onCancel,
      onConfirm,
      cancelBtnText,
      confirmBtnText,
      cancelBtn,
      confirmBtn,
      alert,
    } = this.props;

    const titleElem =
      typeof title === "string" ? <p className="title">{title}</p> : title;

    return (
      <Fragment>
        {isOpen ? (
          <Modal isOpen={isOpen} onClose={onCancel}>
            <div className="dialog">
              {titleElem}
              <div className="description">{children}</div>
              {(cancelBtn || confirmBtn) && (
                <div className="buttons">
                  {cancelBtn && (
                    <Button sm flat cancel onClick={onCancel}>
                      {cancelBtnText}
                    </Button>
                  )}
                  {confirmBtn && alert && (
                    <Button sm danger onClick={onConfirm}>
                      {confirmBtnText}
                    </Button>
                  )}
                  {confirmBtn && !alert && (
                    <Button sm flat submit onClick={onConfirm}>
                      {confirmBtnText}
                    </Button>
                  )}
                </div>
              )}
            </div>
          </Modal>
        ) : null}
      </Fragment>
    );
  }
}

DialogModalWindow.propTypes = {
  isOpen: bool,
  title: oneOfType([string, object]),
  onCancel: func,
  onConfirm: func,
  cancelBtnText: string,
  confirmBtnText: string,
  cancelBtn: bool,
  confirmBtn: bool,
};

DialogModalWindow.defaultProps = {
  isOpen: false,
  title: "",
  onCancel: null,
  onConfirm: null,
  cancelBtnText: "Cancel",
  confirmBtnText: "OK",
  cancelBtn: true,
  confirmBtn: true,
};
